/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LinkMemberToUserRequest } from '../models/LinkMemberToUserRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersMemberLinkService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Link a member to a person.
     * @returns void
     * @throws ApiError
     */
    public linkMemberToUser({
        user,
        requestBody,
    }: {
        /**
         * The ID of the user.
         */
        user: number,
        requestBody: LinkMemberToUserRequest,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/{user}/link',
            path: {
                'user': user,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
